<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 16.5C14 17.0523 13.5523 17.5 13 17.5L7 17.5C6.44772 17.5 6 17.0523 6 16.5L6 14.5L14 14.5L14 16.5Z"
          fill="#2E1E51" fill-opacity="0.54"/>
    <path d="M6 3.5C6 2.94772 6.44772 2.5 7 2.5H13C13.5523 2.5 14 2.94772 14 3.5V14.5H6V3.5Z" fill="#2E1E51"
          fill-opacity="0.2"/>
</svg>
